document.addEventListener('DOMContentLoaded', function () {
  var $hamBurgers = Array.prototype.slice.call(document.querySelectorAll('.hamburger-icon'), 0)

  if ($hamBurgers.length > 0) {
    $hamBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {
        var $iconTarget = document.getElementById('hamburger-icon')
        $iconTarget.classList.toggle('active')
      })
    })
  }

  $('#nav-icon').click(function () {
    $(this).toggleClass('open')
    $('.menu--responsive__ul').slideToggle()
    $('.menu--responsive__sublist').css('display', 'none')
    $('body').toggleClass('overflow-hidden')
    $('.menu--responsive').toggleClass('bg-white bg-blue-100')
  })

  if ($(window).width() < 769) {
    $('.menu--responsive__haschild-a').click(function (e) {
      e.preventDefault()
      $(this).siblings('.menu--responsive__ul').slideToggle()
    })
  }

  $(window).resize(function () {
    if ($(window).width() > 768) {
      $('.menu--responsive__ul').removeAttr('style')
    }
  })
})
